import './impersonator-notification.scss';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import AdminOptions from 'shared/components/AdminOptions';
import { T, useTranslate } from 'shared/helper/translate';
var ImpersonatorNotification = function ImpersonatorNotification() {
  var migrationStatus = useSelector(function (_ref) {
    var user = _ref.user;
    return user.wfoeMigrationStatus;
  });
  var adminDomain = useSelector(function (_ref2) {
    var application = _ref2.application;
    return application.adminDomain;
  });
  var adminRedirect = "https://".concat(adminDomain, "/admin/researcher");
  var userFullName = useSelector(function (_ref3) {
    var user = _ref3.user;
    return user.fullName;
  });
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var showTermsOfServiceNotice = migrationStatus.inMigratingGroup && !(migrationStatus.acceptedTermsOfService && migrationStatus.migrated);
  return /*#__PURE__*/React.createElement(AdminOptions, null, /*#__PURE__*/React.createElement("div", {
    className: "fixed-bottom impersonator-notification text-light p-3 ".concat(showTermsOfServiceNotice ? 'bg-danger' : 'bg-info')
  }, /*#__PURE__*/React.createElement("div", {
    className: "row align-items-center text-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement("small", null, "Currently impersonating ", userFullName), /*#__PURE__*/React.createElement("a", {
    "aria-label": t('stop impersonating'),
    className: "btn btn-secondary ms-2",
    href: "https://".concat(adminDomain, "/api/auth/logout?redirect_uri=").concat(adminRedirect),
    role: "button"
  }, /*#__PURE__*/React.createElement(T, {
    source: "stop impersonating"
  }))), showTermsOfServiceNotice ? /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fw-bold"
  }, /*#__PURE__*/React.createElement("small", null, /*#__PURE__*/React.createElement(T, {
    source: "impersonating-wfoe-user-warning"
  })))) : null)));
};
export default ImpersonatorNotification;